module.exports = __webpack_public_path__ + "img/wenzhang.6b65c0a9.png";